const enjoyUrl = 'https://egplatform.enjoygame.com:7093/';

const isTest = false;
export default{
    enjoyUrl,//地址
    isTest,
    methods: {
        setStorageItem(key,value) {
            if(value instanceof Object){
                value = JSON.stringify(value)
            }
            localStorage.setItem(key,value)
            let timeStamp = Date.parse(new Date())/1000;
            let jsonObj = {'time':timeStamp,'ttl':600}
            localStorage.setItem(key+'_time',JSON.stringify(jsonObj))
        },
        getStorageItem(key) {
            let str =  localStorage.getItem(key+'_time')
            if(str){
                let obj = JSON.parse(str)
                let curTime = Date.parse(new Date())/1000
                if(Math.abs(curTime-obj.time)>=obj.ttl){
                    localStorage.removeItem(key+'_time')
                    localStorage.removeItem(key)
                    return false
                }else{
                    return localStorage.getItem(key)
                }
            }
            localStorage.removeItem(key+'_time')
            localStorage.removeItem(key)
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/global.js